import React from 'react';

import TripReviewContainer from './trip-review-container';

const TripReview = () => <TripReviewContainer />;

export default TripReview;
